export class UpdateRestoreAccountRequest {
    'name';
    'restoreAccountAttributes';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "name",
            "baseName": "name",
            "type": "string",
            "format": ""
        },
        {
            "name": "restoreAccountAttributes",
            "baseName": "restoreAccountAttributes",
            "type": "UpdateRestoreAccountAttributesInput",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return UpdateRestoreAccountRequest.attributeTypeMap;
    }
    constructor() {
    }
}
